import React, { Component } from "react";
import { Route } from "react-router-dom";

// Components

// import Navigation from "./../header/navigation";
import Navigation from "./../header/navigation/Navigation";
import NavBar from "../header/navigation/NavBar";

import BreadCrums from "./breadcrums";
import Footer from "./../footer";
import CustomPage from "./../../common/page";
import TvScreensPage from "../../modules/tvsettings";
import { NavContext } from "./propContext";
import Storage from "./../../services/local-store";

class Body extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      menuList: [],
      currentUnitPlace:JSON.parse(Storage.get("display_name")),
      setCurrentUnitPlace:this.setCurrentUnitPlace.bind(this)
    };
  }
  // componentDidMount() {
  //   console.log(this.props.match);
  // }
  menuData(evnt) {
    this.setState((state) => ({ menuList: evnt }));
  }
  setCurrentUnitPlace(unitplace){
    this.setState({
      currentUnitPlace:unitplace
    })
  }
  render() {
    const { id, slug } = this.props.match.params;
    return (
      <div className="body-wraper">
        {id !== "tv-screen" && (
          <React.Fragment>
            {slug !== "start-counter" && (
              <NavContext.Provider value={this.state}>
              <React.Fragment>
                {/* <Navigation
                  {...this.props}
                  menuData={this.menuData.bind(this)}
                ></Navigation> */}
                {/* <NavBar /> */}
                <Navigation
                  {...this.props}
                  menuData={this.menuData.bind(this)}
                />
                <div className="body-container">
                  <BreadCrums {...this.props} {...this.state}></BreadCrums>
                  <Route
                    path={`/${this.props.match.params.id}/:slug?`}
                    render={(props) => (
                      <CustomPage {...this.props} {...this.state} 
                      />
                    )}
                  />
                </div>
                {/* <Footer {...this.props} {...this.state} /> */}
              </React.Fragment>
              </NavContext.Provider>
            )}
            {slug === "start-counter" && (
              <React.Fragment>
                <Route
                  path={`/${this.props.match.params.id}/:slug?`}
                  render={(props) => (
                    <CustomPage {...this.props} {...this.state} />
                  )}
                />
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        {id === "tv-screen" && (
          <React.Fragment>
            {/* <Route
              path={`/${this.props.match.params.id}/:slug?`}
              render={() => <TvScreensPage {...this.props} />}
            /> */}
            <TvScreensPage {...this.props} {...this.state} />
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default Body;
